import React, { FC, useMemo } from 'react'

import { createFlowLogger, CreateFlowLoggerParams } from './createFlowLogger'
import { FlowLoggerContext } from './FlowLoggerContext'

export const FlowLoggerProvider: FC<CreateFlowLoggerParams> = ({ flowBiSlug, metaSiteId, children }) => {
  const flowLogger = useMemo(() => createFlowLogger({ flowBiSlug, metaSiteId }), [flowBiSlug, metaSiteId])
  return <FlowLoggerContext.Provider value={flowLogger}>{children}</FlowLoggerContext.Provider>
}
